/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { WebhookSubscriptionCommandDtov1 } from '../models/webhook-subscription-command-dtov-1';


/**
 * API for assigning webhook auth configs to a form's events. Ops-only - no UI.
 */
@Injectable({
  providedIn: 'root',
})
export class WebhookFormSubscriptionV1Service extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation getFormWebhookSubscriptionsV1
   */
  static readonly GetFormWebhookSubscriptionsV1Path = '/v1/form-webhook-subscriptions/{formId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getFormWebhookSubscriptionsV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  getFormWebhookSubscriptionsV1$Response(params: {
    formId: string;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<Array<WebhookSubscriptionCommandDtov1>>> {

    const rb = new RequestBuilder(this.rootUrl, WebhookFormSubscriptionV1Service.GetFormWebhookSubscriptionsV1Path, 'get');
    if (params) {
      rb.path('formId', params.formId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WebhookSubscriptionCommandDtov1>>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getFormWebhookSubscriptionsV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getFormWebhookSubscriptionsV1(params: {
    formId: string;
  },
  context?: HttpContext

): Observable<Array<WebhookSubscriptionCommandDtov1>> {

    return this.getFormWebhookSubscriptionsV1$Response(params,context).pipe(
      map((r: StrictHttpResponse<Array<WebhookSubscriptionCommandDtov1>>) => r.body as Array<WebhookSubscriptionCommandDtov1>)
    );
  }

  /**
   * Path part for operation updateFormWebhookSubscriptionsV1
   */
  static readonly UpdateFormWebhookSubscriptionsV1Path = '/v1/form-webhook-subscriptions/{formId}';

  /**
   * Replaces the form's webhook subscription mapping (event type -> auth config ids). Only this field is touched - other form fields are untouched.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateFormWebhookSubscriptionsV1()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateFormWebhookSubscriptionsV1$Response(params: {
    formId: string;
    body: Array<WebhookSubscriptionCommandDtov1>
  },
  context?: HttpContext

): Observable<StrictHttpResponse<Array<WebhookSubscriptionCommandDtov1>>> {

    const rb = new RequestBuilder(this.rootUrl, WebhookFormSubscriptionV1Service.UpdateFormWebhookSubscriptionsV1Path, 'patch');
    if (params) {
      rb.path('formId', params.formId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WebhookSubscriptionCommandDtov1>>;
      })
    );
  }

  /**
   * Replaces the form's webhook subscription mapping (event type -> auth config ids). Only this field is touched - other form fields are untouched.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateFormWebhookSubscriptionsV1$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateFormWebhookSubscriptionsV1(params: {
    formId: string;
    body: Array<WebhookSubscriptionCommandDtov1>
  },
  context?: HttpContext

): Observable<Array<WebhookSubscriptionCommandDtov1>> {

    return this.updateFormWebhookSubscriptionsV1$Response(params,context).pipe(
      map((r: StrictHttpResponse<Array<WebhookSubscriptionCommandDtov1>>) => r.body as Array<WebhookSubscriptionCommandDtov1>)
    );
  }

}
